var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component"},[_c('div',{staticClass:"map-container"},[_c('div',{ref:"map",staticClass:"map"})]),_c('div',{staticClass:"rectangle-container",style:({
      padding: (_vm.rectanglePadding + "px")
    })},[_c('div',{staticClass:"rectangle"})])])}
var staticRenderFns = []

export { render, staticRenderFns }